
import WithdrawalView from 'layouts/vendor/WithdrawalView';
import ProtectedRoute from './ProtectedRoute';
import ManageWithdrawals from 'layouts/vendor/ManageWithdrawals';

const WithdrawalRoutes = [

  {
    route: "/withdrawal/view/:id",
    key: "view-withdrawals",
    component: <ProtectedRoute check="logout"><WithdrawalView /></ProtectedRoute>
  },
  {   
    route: "/withdrawal/list/:pageNo",
    key: "manageWithdrawals",
    component: <ProtectedRoute check="logout"><ManageWithdrawals /></ProtectedRoute>,
  },  
];

export default WithdrawalRoutes;
